import _ from "lodash";
import { GameNode, TagMap } from "./GameState";
import { makeWeakMapCached } from "./makeWeakMapCached";

const nodesByContinent = makeWeakMapCached((nodes: TagMap<GameNode>) =>
    _.groupBy(Object.values(nodes), node => node.continent)
);

export default nodesByContinent;
